import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=722908bf&scoped=true&lang=pug"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"
import style0 from "./Categoria.vue?vue&type=style&index=0&id=722908bf&prod&scoped=true&lang=css"
import style1 from "./Categoria.vue?vue&type=style&index=1&id=722908bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722908bf",
  null
  
)

export default component.exports